import { FieldInputProps, FormikProps } from 'formik';

export function saveFileListToFormikField(
    files: FileList | null,
    field: FieldInputProps<any>,
    form: FormikProps<any>,
    allowMultipleFiles: boolean,
) {
    if (!files || files.length === 0) {
        form.setFieldValue(field.name, '');
    } else {
        if (!allowMultipleFiles && files.length > 1) {
            form.setFieldTouched(field.name, true, false);
            form.setFieldError(field.name, 'Only a single file is accepted');
        }
        form.setFieldValue(field.name, files);
    }
}

export function combineFileLists(fileListArray: FileList[]): FileList {
    const dataTransfer = new DataTransfer();
    const existingFileNames = new Set<string>();

    fileListArray
        .filter((fileList) => fileList != null)
        .flatMap((fileList) => Array.from(fileList))
        .forEach((file) => {
            if (!existingFileNames.has(file.name)) {
                dataTransfer.items.add(file);
                existingFileNames.add(file.name);
            }
        });

    return dataTransfer.files;
}

export function createSingletonFileList(file: File): FileList {
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    return dataTransfer.files;
}

export function validateFileTypes(files: FileList | null, allowedTypes?: string | string[]): string | null {
    if (!files || !allowedTypes || (Array.isArray(allowedTypes) && allowedTypes.length === 0)) {
        return null;
    }

    const allowedTypesArray = Array.isArray(allowedTypes) ? allowedTypes : [allowedTypes];
    const allowedTypesLowerCase = allowedTypesArray.map((type) => type.toLowerCase());

    for (const type of allowedTypesArray) {
        if (!/^[a-zA-Z0-9]+$/.test(type)) {
            return `File extension "${type}" must contain only alphanumeric characters`;
        }
    }

    for (const file of Array.from(files)) {
        const extension = file.name.split('.').pop()?.toLowerCase();
        if (!extension || !allowedTypesLowerCase.includes(extension)) {
            return `File "${file.name}" has an unsupported file type. Allowed types: ${allowedTypesArray.join(', ')}`;
        }
    }

    return null;
}

export function getAcceptAttribute(allowedTypes?: string | string[]): string | undefined {
    if (!allowedTypes || (Array.isArray(allowedTypes) && allowedTypes.length === 0)) {
        return undefined;
    }
    
    const allowedTypesArray = Array.isArray(allowedTypes) ? allowedTypes : [allowedTypes];
    return allowedTypesArray.map((type) => `.${type.toLowerCase()}`).join(', ');
}
